import React from "react";
import { View, StyleSheet, ActivityIndicator } from "react-native";

import { useRecoilValue } from "recoil";
import { authAtom } from "stores";
import { mq } from "utils";

export default function ChatEarlierLoading() {
  const {
    company: { color },
  } = useRecoilValue(authAtom);

  return (
    <View style={styles.container}>
      <ActivityIndicator size={"small"} color={color} />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: "100%",
    height: mq(50),
    alignItems: "center",
    justifyContent: "center",
  },
});
